import {PersistentTrigger, TimeWindowCondition, type TriggerCondition, type TriggerFactory} from "./triggers";
import {Timer, TimerConfig, TimerFactory} from "../../page/elements/timer";
import {GLOBAL} from "../globals";
import {autoRegister, resolve} from "../../container";
import {isPresent} from "../utils/basics";
import type {Nullable} from "../../bootstrap/common/types";

export class InactivityTrigger extends PersistentTrigger {
    private timer: Timer;

    public constructor(
        protected element: Element,
        private timerFactory: TimerFactory,
        triggerConditions: TriggerCondition[],
        callback: () => void
    ) {
        super(triggerConditions, callback);
        const triggerDelay = milliseconds(this.element.getAttribute("data-trigger-delay")) ?? 3000;

        const timerConfig = new TimerConfig()
            .withDelay(triggerDelay)
            .withCallback(() => this.trigger());
        this.timer = this.timerFactory.newTimer(timerConfig);

        for (const event of ["click", "keydown", "scroll", "mousemove"]) {
            GLOBAL.window().addEventListener(event, () => this.timer.refresh());
        }
    }

    public stop(): void {
        super.stop();
        this.timer.stop();
    }
}

const milliseconds = (seconds: Nullable<string>): Nullable<number> => {
    const parsed = seconds?.toFloat();
    return isPresent(parsed) ? parsed * 1000 : null;
};

@autoRegister()
export class InactivityTriggerFactory implements TriggerFactory {
    public constructor(private timerFactory: TimerFactory = resolve(TimerFactory)) {
    }

    public createTrigger(element: Element, callback: () => void): InactivityTrigger {
        return new InactivityTrigger(element, this.timerFactory, TimeWindowCondition.timeWindowCondition(element), callback);
    }
}